import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as TicketsDashboardTableDataItem } from '@/components/tables/TicketsDashboardTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  jobTicketsItem: ReadonlyDeep<
    | openapi.GetTicketDashboardAll_200['results'][0]
    // eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
    | openapi.GetTicketDashboardUnread_200['results'][0]
  >,
): TicketsDashboardTableDataItem {
  let ticketStatusIcon = 'mdi-email-outline';
  if (jobTicketsItem.state === 'Open') {
    ticketStatusIcon = 'mdi-email-open-outline';
  }
  if (jobTicketsItem.state === 'Closed') {
    ticketStatusIcon = 'mdi-email-check-outline';
  }
  const updatedAt = format(
    new TZDate(
      jobTicketsItem.updated_at,
      '+' + jobTicketsItem.updated_at.split('+')[1],
    ),
    'hh:mm a, MMM d, yyyy', // 22:36 PM, Jul 27, 2023
  );

  return {
    subjectId: jobTicketsItem.id,
    subject: getStrCell(jobTicketsItem.title),
    createdBy: getStrCell(jobTicketsItem.created_by),
    customer: getStrCell(jobTicketsItem.customer),
    updatedBy: getStrCell(jobTicketsItem.updated_by),
    updatedAt,
    updatedAtTooltip: jobTicketsItem.updated_at,
    isRfc: jobTicketsItem.is_rfc,
    ticketStatus: jobTicketsItem.state,
    ticketStatusIcon,
    jobs: jobTicketsItem.jobs.map((jobId) => {
      return {
        jobId,
        jobDate: '', // TODO
      };
    }),
  };
}

export function getTableData(
  jobTicketsData:
    | ReadonlyDeep<
        openapi.GetTicketDashboardAll_200 | openapi.GetTicketDashboardUnread_200
      >
    | undefined,
): TicketsDashboardTableDataItem[] {
  const _jobTicketsData: TicketsDashboardTableDataItem[] = [];
  if (!jobTicketsData?.results.length) {
    return _jobTicketsData;
  }
  jobTicketsData.results.forEach(function (jobTicketsItem) {
    _jobTicketsData.push(getTableItem(jobTicketsItem));
  });
  return _jobTicketsData;
}
